import { useEffect } from 'react';

import { useClearedMultipleQueryParamsValues } from 'src/app/shared/hooks/location';
import { useSessionAsync } from 'src/app/shared/hooks/session';
import { useTrackOnce } from 'src/app/shared/hooks/tracking';
import { isLoaded } from 'src/app/shared/utils/async';

export function useShowSurvey(): void {
	const trackOnce = useTrackOnce();
	const session = useSessionAsync();

	const [petitionFeedback, surveyEventUuid, score] = useClearedMultipleQueryParamsValues([
		'petition_feedback',
		'survey_event_uuid',
		'score',
	] as const);

	useEffect(() => {
		if (isLoaded(session)) {
			// Only track if we come from a redirect from the middle-end that previously set the current_source property
			if (petitionFeedback === 'survey_feedback' && session.value.trackingData.current_source) {
				void trackOnce('survey_feedback', {
					survey_event_uuid: surveyEventUuid,
					score: score ? parseInt(score, 10) : undefined,
				});
			}
		}
	}, [session, petitionFeedback, surveyEventUuid, score, trackOnce]);
}
